/**
 * 注册信息Mapper
 *
 * @author zhoujianhui
 * @date 10/28/2021
 * @lastModifiedBy zhoujianhui
 * @lastModifiedDate 10/28/2021
 */
const registerInfoMapper = {
    toDto(registerInfo) {
        const registerInfoDto = {}
        registerInfoDto.username = registerInfo.username
        registerInfoDto.password = registerInfo.password
        registerInfoDto.captchaText = registerInfo.captchaText
        registerInfoDto.captchaToken = registerInfo.captchaToken

        return registerInfoDto
    }
}

export default registerInfoMapper